import { render, staticRenderFns } from "./ReTagGroupList.vue?vue&type=template&id=501aaf4e&scoped=true"
import script from "./ReTagGroupList.vue?vue&type=script&lang=js"
export * from "./ReTagGroupList.vue?vue&type=script&lang=js"
import style0 from "./ReTagGroupList.vue?vue&type=style&index=0&id=501aaf4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501aaf4e",
  null
  
)

export default component.exports